const GRAPH_API_VERSION = 'v1.0';

export const GRAPH_URL = `https://graph.microsoft.com/${GRAPH_API_VERSION}`;

export const ORIGINATOR = '0eb3a855-e2d4-4bc9-8038-b22d614e4788';

export const INGESTION_KEY =
    'c9627dfc0a1c4559b86b405ad2238219-9ce5987f-4f18-4e40-8ece-d8d32edec477-7231';
